import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import NotificationsProvider from '@/contexts/notifications-context';
import { UserProvider } from '@/contexts/user-context';
import { ModalCoordinatorProvider } from '@/contexts/modal-coordinator-context';
import { useAuth } from '@/contexts/auth-context';
import { useNavigationListener } from '@/hooks/useNavigationListener';

const PrivateRoutesWrapper: React.FC = () => {
  const { isAuthorized } = useAuth();
  useNavigationListener();

  if (isAuthorized) {
    return (
      <ModalCoordinatorProvider>
        <UserProvider>
          <NotificationsProvider>
            <Outlet />
          </NotificationsProvider>
        </UserProvider>
      </ModalCoordinatorProvider>
    );
  }
  return <Navigate to="/auth" replace />;
};

export default PrivateRoutesWrapper;
